import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";

import { useCallback } from "react";
import { SubmissionService } from "../../../../services/SubmissionService";
import DocumentTypeRuleTestModal from "../../../queue/components/modals/DocumentTypeRuleTestModal";
import AnalyticsDetailLoading from "../../../jobs/autofile/analytics/AnalyticsDetailLoading";
import DocumentTypeRuleModal from "../../../queue/components/modals/DocumentTypeRuleModal";

export default function Submission({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const [updatedSubmission, setUpdatedSubmission] = useState(submission);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [editable, setEditable] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [updatedFilename, setUpdatedFilename] = useState<string>("");

    useEffect(() => {
        setUpdatedSubmission(submission);
    }, [submission]);

    const onSaveClick = useCallback(
        async (updatedSubmission) => {
            await SubmissionService.update({ body: updatedSubmission }).then(
                (resp) => {
                    console.log(resp);
                    if (resp.successful && resp.data !== (null || undefined)) {
                        setSaving(true);
                        setUpdatedSubmission(resp.data);
                    } else if (!resp.successful) {
                        console.log(resp.errorMessage);
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
            setSaving(false);
            setEditable(!editable);
        },
        [updatedSubmission]
    );

    const sync = () => {
        SubmissionService.sync({
            submissionId: submission.id ?? APIModels.EmptyGuid,
        });
    };

    const cancel = () => {
        SubmissionService.cancel({
            submissionId: submission.id ?? APIModels.EmptyGuid,
            body: {
                defaultMessage: 0,
                message: "Submission was put back into the queue.",
                filter: "All",
                state: "",
            },
        }).then(
            (resp) => {
                if (resp.successful) {
                    setSuccessMessage("Submission was put back in the queue.");
                } else {
                    setErrorMessage(
                        "The submission could not be cancelled, submission has a refrence number: " +
                            submission.referenceNumber
                    );
                }
            },
            (error) => {
                setErrorMessage(
                    "An unforeseen error occurred, the submission could not be put back in the Queue."
                );
            }
        );
    };

    return (
        <div className="card text-center" style={{ maxWidth: "100%" }}>
            <div className="card-header">
                <h5>Submission Editable Fields</h5>
                <div
                    style={{
                        textAlign: "center",
                        marginBottom: "1em",
                    }}
                >
                    <div className="btn-group row">
                        <a
                            style={{
                                marginLeft: "2em",
                                marginRight: "2em",
                                marginBottom: "1em",
                            }}
                            className="btn btn-secondary btn-sm"
                            onClick={() => setEditable(!editable)}
                        >
                            {!editable ? "Edit" : "Editing"}
                        </a>
                        <button
                            style={{ marginLeft: "2em", marginRight: "2em" }}
                            className="btn btn-primary btn-sm"
                            onClick={() => sync()}
                        >
                            Sync
                        </button>
                    </div>
                    <div className="btn-group row">
                        <button
                            style={{
                                marginLeft: "2em",
                                marginRight: "2em",
                                marginBottom: "1em",
                            }}
                            className="btn btn-danger btn-sm"
                            onClick={() => setShow(true)}
                        >
                            Check For Document Type Rule
                        </button>
                        <button
                            style={{ marginLeft: "2em", marginRight: "2em" }}
                            className="btn btn-danger btn-sm"
                            onClick={() => cancel()}
                        >
                            Back to Queue
                        </button>
                    </div>
                </div>
                <div
                    style={{
                        textAlign: "center",
                    }}
                >
                    {errorMessage && (
                        <p>
                            <span style={{ color: "red" }}>{errorMessage}</span>
                        </p>
                    )}
                    {successMessage && (
                        <p>
                            <span style={{ color: "green" }}>
                                {successMessage}
                            </span>
                        </p>
                    )}
                </div>
            </div>
            {updatedSubmission && updatedSubmission.caseData && (
                <DocumentTypeRuleTestModal
                    show={show ?? false}
                    attorneyId={
                        updatedSubmission.attorneyID ?? APIModels.EmptyGuid
                    }
                    county={updatedSubmission.caseData.county}
                    division={updatedSubmission.caseData.division}
                    filename={updatedSubmission.filename ?? ""}
                    onSubmit={() => {
                        // DO NOT DO NOTIN TO THIS
                        setShow(false);
                    }}
                    onClose={() => {
                        setShow(false);
                    }}
                />
            )}
            <div className="card-body">
                <div className="row mb-3">
                    {/* Editable */}
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>File Name</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailFilename"
                                placeholder="Edit Filename"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={updatedSubmission.filename}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        filename: event.currentTarget.value,
                                    })
                                }
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid filename.
                            </div>
                        </div>
                    </div>
                    {/* Editable */}
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Reference Number</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailReferenceNumber"
                                placeholder="Edit Reference Number"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={updatedSubmission.referenceNumber}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        referenceNumber:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid filename.
                            </div>
                        </div>
                    </div>
                    {/* Editable */}
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Portal Identifier</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailPortalIdentifier"
                                placeholder="Edit Portal Identifier"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={updatedSubmission.portalIdentifier}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        portalIdentifier:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    {/* Editable */}
                    <div className="col-sm-12">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailEmergency"
                                readOnly={!editable}
                                onClick={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        emergency: event.currentTarget.checked,
                                    })
                                }
                                disabled={!editable}
                                checked={updatedSubmission.emergency}
                            />
                            <label className="form-check-label">
                                Emergency
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    {/* Editable */}
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Filed Date</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailFiledDate"
                                placeholder="Edit Filed Date"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={
                                    (updatedSubmission?.filedDateTime !==
                                        null &&
                                    updatedSubmission!.filedDateTime !==
                                        undefined
                                        ? new Date(
                                              updatedSubmission?.filedDateTime
                                          ).toDateString()
                                        : new Date(
                                              submission.filedDateTime ??
                                                  "2022/29/3"
                                          ).toDateString() ?? "Not Filed") ??
                                    "Not Filed"
                                }
                                onChange={(event) => () => {
                                    const tar = event.currentTarget.valueAsDate;
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        filedDateTime:
                                            tar !== null
                                                ? tar
                                                : submission?.filedDateTime,
                                    });
                                }}
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                </div>
                {editable && (
                    <>
                        <a
                            className="btn btn-primary"
                            onClick={() => onSaveClick(updatedSubmission)}
                        >
                            Save
                        </a>
                        <a
                            className="btn btn-danger"
                            onClick={() => {
                                setEditable(!editable);
                                window.location.reload();
                            }}
                        >
                            Cancel
                        </a>
                    </>
                )}
                <div>
                    <h5>Submission Uneditable Fields</h5>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Upload Date</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailUploadDate"
                                placeholder="Edit Upload Date"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={
                                    updatedSubmission.uploadedDateTime !==
                                    (null || undefined)
                                        ? String(updatedSubmission?.updatedDate)
                                        : "Not Updated"
                                }
                                onChange={(event) => () => {
                                    const tar = event.currentTarget.valueAsDate;
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        updatedDate:
                                            tar !== null ? tar : undefined,
                                    });
                                }}
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Accepted Date</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailAcceptedDate"
                                placeholder="Edit Accepted Date"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={
                                    updatedSubmission.acceptedDateTime !==
                                    (null || undefined)
                                        ? String(
                                              updatedSubmission?.acceptedDateTime
                                          )
                                        : "Not Accepted"
                                }
                                onChange={(event) => () => {
                                    const tar = event.currentTarget.valueAsDate;
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        acceptedDateTime:
                                            tar !== null ? tar : undefined,
                                    });
                                }}
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Rejected Date</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailRejectedDate"
                                placeholder="Edit Rejected Date"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!editable}
                                value={
                                    updatedSubmission.rejectedDateTime !==
                                    (null || undefined)
                                        ? String(
                                              updatedSubmission?.rejectedDateTime
                                          )
                                        : "Not Rejected"
                                }
                                onChange={(event) => () => {
                                    const tar = event.currentTarget.valueAsDate;
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        rejectedDateTime:
                                            tar !== null ? tar : undefined,
                                    });
                                }}
                                disabled={!editable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Rejected Date.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Status ID</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtStatusID"
                                placeholder="Edit Status ID"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.statusID}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        statusID: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Status ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Updated By</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtUpdatedBy"
                                placeholder="Edit Updated By"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.updatedBy}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        updatedBy: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Status ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Updated Message</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtStatusID"
                                placeholder="Edit Updated Message"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.updatedMessage}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        updatedMessage:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Status ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Updated Date</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtStatusID"
                                placeholder="Edit Updated Date"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.updatedDate?.toString()}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Status ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>submitter Name</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtSubmitterName"
                                placeholder="Edit Submitter Name"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.submitterName}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        submitterName:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Status ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Upload ID</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtStatusID"
                                placeholder="Edit Upload ID"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.uploadID}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        uploadID: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Upload ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Updated By ID</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtUpdatedByID"
                                placeholder="Edit Updated ID"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.updatedByID}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        submitterName:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Updated By ID.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
